var androids = [
  {
    key: 'B00OSTKZWM',
    category: 'android',
    name:
      'RCA M1 4.0 Unlocked Cell Phone, Dual SIM, 5MP Camera, Android 4.4, 1.3GHz (White)',
    seller: 'RCA',
    wholePrice: '57',
    priceFraction: '99',
    stock: 96,
    star: 3,
    starCount: 620,
    discount: 21,
    img:
      'https://images-na.ssl-images-amazon.com/images/I/51VCP05020L._AC_US218_.jpg',
    url:
      'https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_atf_electronics_sr_pg1_1?ie=UTF8&adId=A03332262DHW9SCX1W5WM&url=https%3A%2F%2Fwww.amazon.com%2FRCA-M1-Unlocked-Camera-Android%2Fdp%2FB00OSTKZWM%2Fref%3Dsr_1_1%3Fs%3Delectronics%26ie%3DUTF8%26qid%3D1499124826%26sr%3D1-1-spons%26keywords%3Dandroid%26psc%3D1&qualifier=1499124825&id=1141793968325395&widgetName=sp_atf',
    features: [
      { description: 'Display Size', value: '4.0 inches' },
      { description: 'Computer Memory Size', value: '4 GB' },
      { description: 'Operating System', value: 'Android' },
      { description: 'Cpu Model Speed', value: '1.3 GHz' },
      { description: 'Special Feature', value: 'smartphone' },
    ],
    price: 57.99,
    shipping: 3.99,
  },
  {
    key: 'B01H2E0J5M',
    category: 'android',
    name:
      'BLU R1 HD - 16 GB - Black - Prime Exclusive - with Lockscreen Offers & Ads',
    seller: 'BLU',
    wholePrice: '59',
    priceFraction: '99',
    stock: 5,
    star: 3,
    starCount: 2318,
    discount: 21,
    img:
      'https://images-na.ssl-images-amazon.com/images/I/416TS-ODxfL._AC_US218_.jpg',
    url:
      'https://www.amazon.com/BLU-R1-HD-Exclusive-Lockscreen/dp/B01H2E0J5M/ref=sr_1_2?s=electronics&ie=UTF8&qid=1499124822&sr=1-2&keywords=android',
    features: [
      { description: 'Display Size', value: '5.0 inches' },
      { description: 'Computer Memory Size', value: '16 GB' },
      { description: 'Operating System', value: 'Android 6.0 Marshmallow' },
      { description: 'Display Type', value: 'LCD' },
      { description: 'Special Feature', value: 'card slots' },
    ],
    price: 59.99,
    shipping: 7.99,
  },
  {
    key: 'B0713WPJKX',
    category: 'android',
    name:
      'Celltronics Micro USB Cable,10FT Nylon Braided Tangle-free Data Sync Heavy Duty Android Charging Cable Power Cord High Speed USB2.0 for Samsung HTC LG MP3 Bluetooth Speaker-3 Pack',
    seller: 'Cell-Tronics',
    wholePrice: '10',
    priceFraction: '99',
    stock: 87,
    star: 4,
    starCount: 3392,
    discount: 23,
    img:
      'https://images-na.ssl-images-amazon.com/images/I/61+-qmTKy8L._AC_US218_.jpg',
    url:
      'https://www.amazon.com/Celltronics-Tangle-free-Charging-Bluetooth-Speaker-3/dp/B0713WPJKX/ref=sr_1_3?s=electronics&ie=UTF8&qid=1499124822&sr=1-3&keywords=android',
    features: [],
    price: 10.99,
    shipping: 3.99,
  },
  {
    key: 'B01LPZD1N6',
    category: 'android',
    name:
      'ATOTO 7"HD Touchscreen 2Din Android Car Navigation Stereo - Quadcore Car Entertainment Multimedia w/ FM/RDS Radio,WIFI,BT,Mirror Link,and more(No DVD Player)M4171 (178101/16G)',
    seller: 'ATOTO',
    wholePrice: '164',
    priceFraction: '90',
    stock: 20,
    star: 3,
    starCount: 4029,
    discount: 25,
    img:
      'https://images-na.ssl-images-amazon.com/images/I/51xI8gJTNYL._AC_US218_.jpg',
    url:
      'https://www.amazon.com/ATOTO-Touchscreen-Android-Navigation-Stereo/dp/B01LPZD1N6/ref=sr_1_4?s=electronics&ie=UTF8&qid=1499124822&sr=1-4&keywords=android',
    features: [
      { description: 'Display Size', value: '7.0 inches' },
      { description: 'Operating System', value: 'Android' },
      { description: 'Hardware Platform', value: 'Android' },
      { description: 'Cpu Model Manufacturer', value: 'MTK' },
      { description: 'Wireless Communication Technology', value: 'AM/FM' },
    ],
    price: 164.9,
    shipping: 0,
  },
  {
    key: 'B01N1SE4EP',
    category: 'android',
    name:
      'NeuTab 7 inch Quad Core Android 5.1 Lollipop Tablet PC, Bluetooth 4.0, Dual Camera, FCC Certified(2017 Upgraded Edition)',
    seller: 'NeuTab',
    wholePrice: '49',
    priceFraction: '99',
    stock: 50,
    star: 3,
    starCount: 4947,
    discount: 27,
    img:
      'https://images-na.ssl-images-amazon.com/images/I/41HNbRSKpfL._AC_US218_.jpg',
    url:
      'https://www.amazon.com/NeuTab-Lollipop-Bluetooth-Certified-Upgraded/dp/B01N1SE4EP/ref=sr_1_5?s=electronics&ie=UTF8&qid=1499124822&sr=1-5&keywords=android',
    features: [
      { description: 'Display Size', value: '7.0 inches' },
      { description: 'Operating System', value: 'android 5.1 (Lollipop)' },
      { description: 'Hard Disk Size', value: '8.0 GB' },
      { description: 'Connectivity Technology', value: 'usb' },
      { description: 'System Ram Type', value: 'ddr3 sdram' },
    ],
    price: 49.99,
    shipping: 7.99,
  },
  {
    key: 'B017LDNLIG',
    category: 'android',
    name: 'Tracfone Alcatel Onetouch Pixi Glitz A463BG',
    seller: 'Tracfone',
    wholePrice: '19',
    priceFraction: '94',
    stock: 85,
    star: 3,
    starCount: 381,
    discount: 29,
    img:
      'https://images-na.ssl-images-amazon.com/images/I/51QdgznaNTL._AC_US218_.jpg',
    url:
      'https://www.amazon.com/Tracfone-Alcatel-Onetouch-Glitz-A463BG/dp/B017LDNLIG/ref=sr_1_6?s=electronics&ie=UTF8&qid=1499124822&sr=1-6&keywords=android',
    features: [
      { description: 'Display Size', value: '3.5' },
      { description: 'Computer Memory Size', value: '2 GB' },
      { description: 'Operating System', value: 'Android 4.4 KitKat' },
      { description: 'Display Type', value: 'LCD' },
      { description: 'Special Feature', value: 'smartphone' },
    ],
    price: 19.94,
    shipping: 7.99,
  },
  {
    key: 'B018IZ0SWI',
    category: 'android',
    name: 'BLU Advance 5.0 - Unlocked Dual Sim Smartphone - US GSM - Black',
    seller: 'BLU',
    wholePrice: '59',
    priceFraction: '99',
    stock: 10,
    star: 3,
    starCount: 395,
    discount: 31,
    img:
      'https://images-na.ssl-images-amazon.com/images/I/41mXjdLezRL._AC_US218_.jpg',
    url:
      'https://www.amazon.com/BLU-Advance-5-0-Unlocked-Smartphone/dp/B018IZ0SWI/ref=sr_1_7?s=electronics&ie=UTF8&qid=1499124822&sr=1-7&keywords=android',
    features: [
      { description: 'Display Size', value: '5 inches' },
      { description: 'Computer Memory Size', value: '4 GB' },
      { description: 'Operating System', value: 'Android' },
      {
        description: 'Wireless Communication Technology',
        value: 'GSM, 3G, 4G',
      },
      { description: 'Cpu Model Speed', value: '1 GHz' },
    ],
    price: 59.99,
    shipping: 3.99,
  },
  {
    key: 'B01N4HS7B8',
    category: 'android',
    name:
      'Smart tv box Wechip V5 Android 6.0 Marshmallow 2g 16g Amlogic S905X quad core 4K Dual WiFi',
    seller: 'Wechip',
    wholePrice: '53',
    priceFraction: '99',
    stock: 34,
    star: 4,
    starCount: 4740,
    discount: 20,
    img:
      'https://images-na.ssl-images-amazon.com/images/I/41q+adG0lNL._AC_US218_.jpg',
    url:
      'https://www.amazon.com/Smart-Wechip-Android-Marshmallow-Amlogic/dp/B01N4HS7B8/ref=sr_1_8?s=electronics&ie=UTF8&qid=1499124822&sr=1-8&keywords=android',
    features: [],
    price: 53.99,
    shipping: 7.99,
  },
  {
    key: 'B01LX0JZUM',
    category: 'android',
    name:
      'ONSON Android Charger Cable,3Pack 10FT Extra Long Nylon Braided High Speed 2.0 USB to Micro USB Charging Cord Fast Charger Cable for Samsung Galaxy S7/S6 Edge,Note 5/4,HTC,LG,Nexus(Gray White)',
    seller: 'ONSON',
    wholePrice: '11',
    priceFraction: '99',
    stock: 8,
    star: 3,
    starCount: 2636,
    discount: 22,
    img:
      'https://images-na.ssl-images-amazon.com/images/I/51P8qI8KzNL._AC_US218_.jpg',
    url:
      'https://www.amazon.com/ONSON-Android-Charger-Braided-Charging/dp/B01LX0JZUM/ref=sr_1_9?s=electronics&ie=UTF8&qid=1499124822&sr=1-9&keywords=android',
    features: [],
    price: 11.99,
    shipping: 3.99,
  },
];

export default androids;
